import type { ITreeFlattenItem } from '@patsnap-biz/corp-tree/types/corpTree';
import type { CompanyName } from './company-name-api';

/**
 * 获取公司树请求参数
 */
export interface GetCompanyTreeRequest {
    /** 是否激活 */
    active?: boolean;
    /** 是否精确匹配 */
    exact_match?: boolean;
    /** 查询关键词 */
    q?: string;
    /** 返回行数 */
    rows?: string;
}

/**
 * 公司树节点项
 */
export interface CompanyTreeItemDTO extends CompanyName {
    /** 答案ID */
    ans_id: string;
    /** 子节点 */
    children: CompanyTreeItemDTO[];
    /** ID */
    id: string;
    /** 投资百分比 */
    invest_percent: number;
    /** 是否展开 */
    is_expanded: boolean;
    /** 是否不活跃 */
    is_inactive: boolean;
    /** 是否其他答案 */
    is_other_ans: boolean;
    /** 专利标签 */
    patent_label: string;
    /** 树标签 */
    tree_label: string;
}

/**
 * 获取公司树响应
 */
export interface GetCompanyTreeResponse {
    /** 关键词列表 */
    keywords: string[];
    /** 公司树结果 */
    result: CompanyTreeItemDTO[];
}

export const GetCompanyTreeApi = Symbol.for('GetCompanyTreeApi');

/**
 * 获取公司树结构 API
 */
export interface GetCompanyTreeApi {
    /**
     * 获取公司树结构
     * @param data 请求参数
     */
    getCompanyTree(data: GetCompanyTreeRequest): Promise<GetCompanyTreeResponse>;
}
